/* unplugin-vue-components disabled */import { render } from "./po-summary-item.vue?vue&type=template&id=0277ce9d"
import script from "./po-summary-item.vue?vue&type=script&lang=js"
export * from "./po-summary-item.vue?vue&type=script&lang=js"

import "./po-summary-item.vue?vue&type=style&index=0&id=0277ce9d&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__